var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"f-ellipsis",class:_vm.cssClass},[_c('span',[_vm._t("prefix")],2),(_vm.overflow === 'middle')?[_c('span',{staticClass:"left-chars"},[_vm._v(_vm._s(_vm.leftChars)+" ")]),_c('span',{staticClass:"right-chars"},[_vm._v(_vm._s(_vm.rightChars)+" ")])]:[_vm._v(" "+_vm._s(_vm.cText)+" ")],_c('span',[_vm._t("suffix")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }